import React from 'react';
import { View } from 'react-native';
import AppStyles from '../../AppStyles';
import { CommonHeader } from '../../utils/widgets/CommonWidget/CommonHeader';
import ProfileComponent from '../tab-component/ProfileComponent';

const ProfileDetails = (props) => {
    return (
        <View >
            <CommonHeader title={'Profile'} navigation={props.navigation} />
            <View style={[AppStyles.screenViewWithHeader]}>
                <ProfileComponent
                    navigation={props.navigation}
                    route={props.route} />
            </View>
        </View>)
}

export default ProfileDetails;
